module.exports = __webpack_public_path__ + "img/texture.6578c05e.gif";